import { styled } from "@mui/material/styles";
import Colors from "../../../../general/constants/colors";
import BreakPoints from "../../../../general/constants/breakPoints";

// из за новых шрифтов хедера - диз сократил его ширину - поэтому весь макет стал уже - а страницы под прежней шириной
// позже переделать на новую ширину и выровнять страницы - не знаю насколько сойдётся
export const Header = styled("header")(() => ({
	backgroundColor: Colors.GREY_OLD,
	padding: "32px 64px 0 64px", // "30px 165px 0 165px",
	margin: "0",
	alignItems: "center",
	zIndex: 10,
	boxSizing: "border-box",
	[`@media (min-width: ${BreakPoints.TABLET_1023}px) and (max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			padding: "20px 16px",
		},
	[`@media (min-width: ${BreakPoints.MOBILE_767}px) and (max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			padding: "16px 16px",
		},
	[`@media (max-width: ${BreakPoints.MOBILE_767}px)`]: {
		padding: "16px 16px",
	},
}));

export const HeaderWrapper = styled("div")(() => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	backgroundColor: Colors.WHITE,
	boxShadow: "0px 4px 16px 0px #7474741F",
	borderRadius: "24px",
	padding: "0 26px",
	height: "96px",
	[`@media (min-width: ${BreakPoints.TABLET_1023}px) and (max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			height: "88px",
		},
	[`@media (min-width: ${BreakPoints.MOBILE_767}px) and (max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			height: "72px",
		},
	[`@media (max-width: ${BreakPoints.MOBILE_767}px)`]: {
		height: "70px",
	},
}));

// логотип и название и подпись
export const Image = styled("a")(({ theme }) => ({
	cursor: "pointer",
	"& svg": {
		width: "280px",
		height: "52px",
	},
	[`@media (max-width:${BreakPoints.LARGE_1439}px)`]: {
		display: "none",
	},
}));

// логотип и название
export const MobileLogo = styled("a")(() => ({
	[`@media (min-width:${BreakPoints.TABLET_1023}px)`]: {
		display: "none",
	},
}));

// логотип
export const ShortLogo = styled("a")(({ theme }) => ({
	[`@media (min-width:${BreakPoints.LARGE_1439}px)`]: {
		display: "none",
	},
	[`@media (min-width:${BreakPoints.TABLET_1023}px) and (max-width:${BreakPoints.LARGE_1439}px)`]:
		{
			display: "block",
		},
	[`@media (max-width:${BreakPoints.TABLET_1023}px)`]: {
		display: "none",
	},
}));

export const Wrapper = styled("div")(() => ({
	"& > a": {
		marginRight: "28px",
	},
	[`@media (min-width:${BreakPoints.TAPOK_319}px) and (max-width:${BreakPoints.FHD_1919}px)`]:
		{
			"& > a": {
				marginRight: "auto",
			},
		},
}));
